import type { estypes } from '@elastic/elasticsearch'

export const superLinearMetadataMapping = {
  identifier: {
    type: 'keyword',
    index: false,
  },
  creator: {
    type: 'keyword',
    index: false,
  },
  assignee: {
    type: 'keyword',
    index: false,
  },
  priorityLabel: {
    type: 'keyword',
    index: false,
  },
  priority: {
    type: 'float',
    index: false,
  },
  labels: {
    type: 'keyword',
    index: false,
  },
  state: {
    type: 'keyword',
    index: false,
  },
  stateType: {
    type: 'keyword',
    index: false,
  },
  cycle: {
    type: 'keyword',
    index: false,
  },
  cycleNumber: {
    type: 'float',
    index: false,
  },
  project: {
    type: 'keyword',
    index: false,
  },
  estimate: {
    type: 'float',
    index: false,
  },
  archivedAt: {
    type: 'date',
    index: false,
  },
  canceledAt: {
    type: 'date',
    index: false,
  },
  completedAt: {
    type: 'date',
    index: false,
  },
  team: {
    type: 'keyword',
    index: false,
  },
} satisfies Record<string, estypes.MappingProperty>
